<template>
  <div class="rc-header-container">
    <div class="header">
      <div class="toggle-menu">
        <div class="logo-responsive">
          <router-link :to="pathHome">
            <img :src="m_event !== null ? m_event.logo_img : logoImg" alt />
          </router-link>
        </div>
      </div>

      <div class="redLine"></div>

      <div class="btn_group pt-1">
        <div class="btn_group_sub slash">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="btn_item btn_item_dropdown"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ select }}
                <v-icon class="icon-language">{{ arrowDown }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in dataLanguage"
                :key="index"
                v-on:click="changeLanguage(item.lang_code, item.lang_name)"
              >
                <v-list-item-title>{{ item.lang_name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div class="btn_group_sub">
          <v-btn
            class="btn_item btn_logout"
            text
            color="#fff"
            @click="handleShowDetail"
          >
            {{ $t('header.logout', { split: '/' }) }}
          </v-btn>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="520">
      <v-card class="dialog-container">
        <v-icon color="#E8320D" class="close-icon" @click="handleCloseDialog">{{
          closeIcon
        }}</v-icon>
        <div class="dialog">
          <h4 v-html="$t('header.notify-logout', { split: '/' })"></h4>
          <v-card-actions>
            <v-btn
              class="btn-logout"
              depressed
              color="#e8320e"
              @click="handleLogout"
            >
              <!-- <router-link tag="span" :to="pathDefault"> -->
              {{ $t('header.btn-logout', { split: '/' }) }}
              <!-- </router-link> -->
            </v-btn>

            <v-btn @click="handleCloseDialog" outlined color="#e8320e">
              {{ $t('header.btn-cancer', { split: '/' }) }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <div class="mainLogo">
      <div class="logo">
        <router-link :to="pathHome">
          <img v-bind:src="m_event !== null ? m_event.logo_img : logoImg" alt />
        </router-link>
        <router-link :to="pathHome" class="home-link">
          <h2>{{ m_event !== null && m_event.event_name }}</h2>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mdiBell,
  mdiFacebook,
  mdiEarth,
  mdiEmail,
  mdiChevronDown,
  mdiMenu,
  mdiClose
} from '@mdi/js';

import { mapGetters } from 'vuex';

import { LANG_CODE_JAPANESE, LANG_CODE_VIETNAMESE } from '@/common/constants';
import { Trans } from '@/plugins/translation.js';

export default {
  data: () => ({
    bellIcon: mdiBell,
    fbIcon: mdiFacebook,
    webIcon: mdiEarth,
    mailIcon: mdiEmail,
    menuIcon: mdiMenu,
    closeIcon: mdiClose,
    arrowDown: mdiChevronDown,
    title: 'TOP',
    menu: true,
    bannerImage: '',
    currentRoute: 'homepage',
    select: '',
    dataLanguage: [
      { key: LANG_CODE_JAPANESE, title: '日本語/Eng' },
      { key: LANG_CODE_VIETNAMESE, title: 'Tiếng Việt' }
    ],
    isActive: false,

    drawer: null,
    banner: false,
    dialog: false,
    logoImg: `/image/logoMain.svg`
  }),

  watch: {
    '$route.name': function () {
      this.currentRoute = this.$route.name;
    }
  },

  methods: {
    toggleMenu() {
      this.isActive = !this.isActive;
    },

    getLanguageFromLS() {
      const keyStore = this.getContractId + this.getEventCode;

      const objFromLS =
        localStorage.getItem(keyStore) !== null
          ? JSON.parse(localStorage.getItem(keyStore))
          : null;

      return objFromLS.sekisho_lang || null;
    },

    setLanguageFromLS(_lang) {
      const keyStore = this.getContractId + this.getEventCode;

      const objFromLS =
        localStorage.getItem(keyStore) !== null
          ? JSON.parse(localStorage.getItem(keyStore))
          : null;

      const newObj = {
        ...objFromLS,
        sekisho_lang: _lang
      };

      localStorage.setItem(keyStore, JSON.stringify(newObj));
    },

    async changeLanguage(lang, title) {
      this.select = title;
      await this.$store.dispatch('changeLanguage', { lang });

      Trans.changeLanguage(lang);
    },

    checkCurrentLanguage() {
      const { query } = this.$route;

      if (
        query.lang &&
        (query.lang == LANG_CODE_VIETNAMESE || query.lang == LANG_CODE_JAPANESE)
      ) {
        const langActive = this.dataLanguageFromServer.filter(
          (lang) => lang.lang_code === query.lang
        );

        this.select = langActive.length > 0 ? langActive[0].lang_name : '';

        this.changeLanguage(query.lang, this.select);

        return;
      }

      const lang = this.getLanguageFromLS();

      if (lang !== null) {
        const langActive = this.dataLanguageFromServer.filter(
          (language) => language.lang_code === lang
        );

        this.select = langActive.length > 0 ? langActive[0].lang_name : '';
        this.changeLanguage(lang, this.select);
      }
    },

    handleLogout() {
      const eventInfo =
        this.$store.state.contract_id + this.$store.state.event_code;
      const token =
        localStorage.getItem(eventInfo).token_rc &&
        localStorage.getItem(eventInfo).token_rc;

      if (token !== null) {
        this.$store.dispatch('logoutReceptionist');
        this.$router.push(this.pathDefault);
      }
    },

    handleShowDetail() {
      this.dialog = true;
    },
    handleCloseDialog() {
      this.dialog = false;
    },

    returnUrlPath(url) {
      const route = this.pathHome + url;

      return route;
    }
  },

  created() {
    this.currentRoute = this.$route.name;
    this.checkCurrentLanguage();
  },

  computed: {
    ...mapGetters({
      m_event: 'getEventData',
      c_language: 'getCLanguage',
      getContractId: 'getContractId',
      getEventCode: 'getEventCode'
    })
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/receptionist/header.scss';
</style>
